import { useAuth } from '../auth/AuthContext.tsx';

/** Bandeau permanent quand le Super Admin agit en tant qu'un autre compte, avec le retour à son propre compte. */
export function ImpersonationBanner() {
  const { user, stopImpersonation } = useAuth();
  if (!user?.impersonating) return null;
  return (
    <div role="status" style={{ position: 'sticky', top: 0, zIndex: 50, background: 'var(--danger)', color: '#fff', padding: '8px 14px', fontSize: 13, display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'center', flexWrap: 'wrap' }}>
      <span>
        Vous agissez en tant que <strong>{user.firstName} {user.lastName}</strong>{user.isDemo ? ' (démo)' : ''}. Paiements, messages et envois aux tiers sont désactivés.
      </span>
      <button type="button" className="btn btn-sm" style={{ background: '#fff', color: 'var(--danger)', width: 'auto', padding: '4px 12px' }} onClick={() => stopImpersonation()}>
        Quitter ({user.impersonating.by})
      </button>
    </div>
  );
}
